import multiavatar from '@multiavatar/multiavatar'

/**
 * 生成用户头像SVG
 * @param {string} identifier - 用户标识符（邮箱、用户名等）
 * @returns {string} SVG字符串
 */
export function generateAvatar(identifier) {
  try {
    // 使用multiavatar生成SVG头像
    const avatarSvg = multiavatar(identifier)
    return avatarSvg
  } catch (error) {
    console.error('生成头像失败:', error)
    // 返回默认头像
    return generateDefaultAvatar()
  }
}

/**
 * 生成默认头像（当multiavatar失败时使用）
 * @returns {string} 默认SVG头像
 */
function generateDefaultAvatar() {
  return `<svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <circle cx="50" cy="50" r="50" fill="#e0e0e0"/>
    <circle cx="50" cy="40" r="20" fill="#ffffff"/>
    <circle cx="40" cy="40" r="5" fill="#666666"/>
    <circle cx="60" cy="40" r="5" fill="#666666"/>
    <path d="M35 60 Q50 70 65 60" stroke="#666666" stroke-width="2" fill="none"/>
  </svg>`
}

/**
 * 将SVG转换为Data URL
 * @param {string} svg - SVG字符串
 * @returns {string} Data URL
 */
export function svgToDataUrl(svg) {
  const encodedSvg = encodeURIComponent(svg)
  return `data:image/svg+xml,${encodedSvg}`
}

/**
 * 生成头像并转换为Data URL
 * @param {string} identifier - 用户标识符
 * @returns {string} Data URL格式的头像
 */
export function generateAvatarDataUrl(identifier) {
  const svg = generateAvatar(identifier)
  return svgToDataUrl(svg)
}
